import { render, staticRenderFns } from "./Landnav.vue?vue&type=template&id=3aff08d0&scoped=true&"
import script from "./Landnav.vue?vue&type=script&lang=js&"
export * from "./Landnav.vue?vue&type=script&lang=js&"
import style0 from "./Landnav.vue?vue&type=style&index=0&id=3aff08d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff08d0",
  null
  
)

export default component.exports